import PropTypes from "prop-types"
import React, { PureComponent } from "react"
import classnames from "classnames"

import Translate from "../../../../app/scripts/components/Translate"
import { omitRedundantFields } from "../../consts/form"

export default class NewTextAreaField extends PureComponent {
  static propTypes = {
    value: PropTypes.string, // required, but nullable
    onChange: PropTypes.func.isRequired,
    // optional
    label: PropTypes.node,
    error: PropTypes.string,
    required: PropTypes.bool,
    // customizators
    touched: PropTypes.bool,
    dataTest: PropTypes.string,
  }

  // render
  // ===
  renderError(error) {
    return (
      <div className="spField-error">
        <Translate tKey={error} className="spField-note spTypo-note" />
      </div>
    )
  }

  renderLabel(label, required) {
    return (
      <div className="spField-label">
        {label}
        {required ? "*" : ""}
      </div>
    )
  }

  render() {
    const { value, label, required, error, touched, onChange, dataTest } = this.props

    const classes = classnames("NewTextAreaField", "spField", {
      _error: error && touched,
      _ok: !error && touched,
      _hasLabel: label,
      _twoLines: true,
    })

    // Warning: `value` prop on `input` should not be null.
    // Consider using the empty string to clear the component or `undefined` for uncontrolled components.
    // -> value || ""

    return (
      <div className={classes} data-test={dataTest}>
        <label>
          {label && this.renderLabel(label, required)}
          {error && touched && this.renderError(error)}

          <textarea
            type="text"
            className="spField-input _textarea"
            {...omitRedundantFields(this.props)}
            value={value || ""}
            onChange={ev => onChange(ev.target.value)}
          />
        </label>
      </div>
    )
  }
}
